import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderDetailsProductObject } from 'src/app/models/orders/order-details-product/order-details-product-object.model';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsProductConverter implements Converter<OrderDetailsProductObject> {

    constructor() { }

    convert(input: any): OrderDetailsProductObject {
        if (isNullOrUndefined(input)) {
            return OrderDetailsProductObject.create();
        }
        return new OrderDetailsProductObject(StringUtils.default(input.action), StringUtils.default(input.name),
            StringUtils.default(input.id));
    }
}
